<mobi-breadcrumb />
<div class="mobi-ui-grid is-centered mobi-ui-margin-b-md">
  <div
    class="mobi-ui-col-1/1 md:mobi-ui-col-2/3 lg:mobi-ui-col-5/8 mobi-ui-text-center view-enter-animation"
  >
    <h1 id="general-agency-title" [innerHtml]="formattedTitle()"></h1>
    <p class="text-lead mobi-ui-margin-b-xxs">
      @defer (hydrate never) {
        {{ openingHours() }}
      }
    </p>
    @if (locations() && locations()?.length) {
      <a
        class="locations-anchor inline-flex justify-center items-center text-black"
        [betterRouterLink]="
          '#' +
          ('locations_content_link_paramenter_name'
            | texts: { context: 'frontend', default: 'standorte' }
            | anchorFormatter)
        "
      >
        <mobi-ui-icon-major name="arrow_lower_right" size="sm" />
        <span class="whitespace-nowrap mobi-ui-font-size-100">
          {{
            'locations_more'
              | texts
                : {
                    context: 'frontend',
                    default: 'Weitere Standorte und Öffnungszeiten',
                  }
          }}
        </span>
      </a>
    }
  </div>
</div>
@if (image()) {
  <div class="mobi-ui-general-agency-header mobi-ui-grid is-centered mobi-ui-margin-b-md">
    <div class="mobi-ui-col-1/1 xl:mobi-ui-col-3/4">
      <div class="hero-image-animation-wrapper relative">
        <mobi-media
          [animation]="false"
          class="mobi-ui-animation-appear-left-init mobi-ui-animation-appear-left-render is-delayed-300"
          rounded="left"
          [entity]="image()"
          responsiveStyle="hero_single"
          [lazy]="false"
        />
        @if (mainAgency()?.googlePlacesId && !mainAgency()?.hideGoogleRatings) {
          @defer (hydrate never) {
            <mobi-google-rating
              placeId="{{ mainAgency()?.googlePlacesId }}"
              [isInHeader]="true"
            />
          }
        }
      </div>
    </div>
  </div>
}

<div class="view-enter-animation">
  <div class="mobi-ui-grid is-centered">
    <div class="mobi-ui-col-1/1 md:mobi-ui-col-2/3 lg:mobi-ui-col-5/8">
      @if (secondaryTitle()) {
        <h2>
          {{ secondaryTitle() }}
        </h2>
      }
      @if (lead()) {
        <mobi-text class="text-lead block" [data]="lead() ?? ''" />
      }
      @if (moreText()) {
        <mobi-ui-expander-silent
          [title]="expanderTitle"
          class="is-inline mobi-ui-margin-t-sm"
          [contentAriaLabel]="
            'ga_more_info'
              | texts: { context: 'frontend', default: 'Mehr über unsere Agentur' }
          "
          [content]="expanderContent"
        />
        <ng-template #expanderTitle>
          <div class="items-center text-lead mobi-ui-font-bold mobi-ui-flex">
            <span class="mobi-ui-padding-r-xxs">{{
              'ga_more_info'
                | texts: { context: 'frontend', default: 'Mehr über unsere Agentur' }
            }}</span>
            <mobi-ui-icon-major name="down" />
          </div>
        </ng-template>
        <ng-template #expanderContent>
          <mobi-text class="text-lead" [data]="moreText() ?? ''" />
        </ng-template>
      }
      <div class="mobi-ui-margin-t-lg">
        @if (contentLinks()) {
          <mobi-content-links [contentLinks]="contentLinks()" />
        }
      </div>
    </div>
  </div>
</div>
